import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Section from './Section'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    overflowY: 'scroll',
    fontFamily: "'Droid Serif', serif",
    fontSize: '14px',
    color: '#2f2f2f',
    backgroundColor: '#f9f7f1',
    padding: '10px',
    '& header': {
      fontFamily: "'Playfair Display', serif",
      fontWeight: '900',
      fontSize: '80px',
      textTransform: 'uppercase',
      display: 'inline-block',
      lineHeight: '142px',
      marginBottom: '20px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '40px',
        lineHeight: '36px',
      },
    },
    '& p': {
      marginTop: '0px',
      marginBottom: '20px',
    },
  },
}))

const HeraldPage = ({
  page,
  date,
}) => {
  const classes = useStyles()
  const dt = new Date(date)

  console.log(page)

  return (
    <div className={ classes.root }>
      <div className="head">
        <div className="header">
          
          <div className="headerBox">
            <span style={{fontStyle: 'italic'}}>
              <strong>Creature of the day:</strong> { page.creatureStory?.creature?.name || '' }
            </span>
            <br/>
            <span>
            { page.creatureStory?.creature?.description || '' }
            </span>
          </div>

          <header>
            The Daily Cauldron
          </header>
        </div>

        <div className="subhead">
          { dt.toLocaleDateString('en-US', {
            weekday: 'long',
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          })
        }
        </div>
      </div>

      <div className="content">
        <div className="collumns">

          <Section
            preHeadline={ `Book review: ${page.bookReleased?.extracted}` }
            headline={ page.bookReleased?.headline || '' }
            caption={ page.bookReleased?.caption || '' }
            story={ page.bookReleased?.story || '' }
            quote={ page.bookReleased?.quote || '' }
            headlineStyle="hl1"
            captionStyle="hl2"
          />

          <Section
            preHeadline="Feature Story:"
            headline={ page.majorStory?.headline || '' }
            caption={ page.majorStory?.caption || '' }
            story={ page.majorStory?.story || '' }
            quote={ page.majorStory?.quote || '' }
            image={ page.images?.majorStory }
            headlineStyle="hl3"
            captionStyle="hl4"
          />

          <Section
            preHeadline="The Elusive Eleanor Taylor:"
            headline={ page.creatureStory?.headline || '' }
            caption={ page.creatureStory?.caption || '' }
            story={ page.creatureStory?.story || '' }
            quote={ page.creatureStory?.quote || '' }
            image={ page.images?.creatureStory }
            headlineStyle="hl1"
            captionStyle="hl2"
          />

          <Section
            preHeadline={ `Birthday: ${page.personBorn?.extracted}` }
            headline={ page.personBorn?.headline || '' }
            caption={ page.personBorn?.caption || '' }
            story={ page.personBorn?.story || '' }
            quote={ page.personBorn?.quote || '' }
            headlineStyle="hl3"
            captionStyle="hl4"
          />

        </div>
      </div>
    </div>
  )
}

export default HeraldPage